/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EstimatedActivity,
  EstimatedActivity$inboundSchema,
  EstimatedActivity$Outbound,
  EstimatedActivity$outboundSchema,
} from "./estimatedactivity.js";

export type CollectFundsAch = {
  estimatedActivity?: EstimatedActivity | undefined;
};

/** @internal */
export const CollectFundsAch$inboundSchema: z.ZodType<
  CollectFundsAch,
  z.ZodTypeDef,
  unknown
> = z.object({
  estimatedActivity: EstimatedActivity$inboundSchema.optional(),
});
/** @internal */
export type CollectFundsAch$Outbound = {
  estimatedActivity?: EstimatedActivity$Outbound | undefined;
};

/** @internal */
export const CollectFundsAch$outboundSchema: z.ZodType<
  CollectFundsAch$Outbound,
  z.ZodTypeDef,
  CollectFundsAch
> = z.object({
  estimatedActivity: EstimatedActivity$outboundSchema.optional(),
});

export function collectFundsAchToJSON(
  collectFundsAch: CollectFundsAch,
): string {
  return JSON.stringify(CollectFundsAch$outboundSchema.parse(collectFundsAch));
}
export function collectFundsAchFromJSON(
  jsonString: string,
): SafeParseResult<CollectFundsAch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CollectFundsAch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CollectFundsAch' from JSON`,
  );
}
